import { render, staticRenderFns } from "./ordersettingaction.vue?vue&type=template&id=625116a8&scoped=true&"
import script from "./ordersettingaction.vue?vue&type=script&lang=js&"
export * from "./ordersettingaction.vue?vue&type=script&lang=js&"
import style0 from "./ordersettingaction.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ordersettingaction.vue?vue&type=style&index=1&id=625116a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625116a8",
  null
  
)

export default component.exports